forms-orders-save
  .orders_based_on_info.mb-5(if="{opts.original_id}")
    .alert.alert-warning(if="{!opts.orders_table.items}")
      a.strong.mr-2(href="{opts.original_order_show_path}" target="_blank") { opts.original_job_no }
      span {locale().no_copied_orders}
    .alert.alert-info(if="{opts.orders_table.items.length > 0}")
      a.strong.mr-2(href="{opts.original_order_show_path}" target="_blank") { opts.original_job_no }
      span.mr-2
        | {locale().has_copied_orders_prefix}
      a.mr-2(each="{item in opts.orders_table.items}" href="{item.show_path}" target="_blank")
        | { item.job_no }
      span
        | {locale().has_copied_orders_suffix}
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.original_id")
    inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.stage")
    inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.client_id")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.client_person_name")    
    inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.user_id")
    inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.product_id")
    inputs-textfield(tag-scope="{ this.tagScope }.inputs.job_no")    
    inputs-number(tag-scope="{ this.tagScope }.inputs.required_num")
    inputs-date(tag-scope="{ this.tagScope }.inputs.deadline")
    inputs-date(tag-scope="{ this.tagScope }.inputs.brifing_date")
    inputs-date(tag-scope="{ this.tagScope }.inputs.deadline_preferred")
    inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.order_type")
    inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.status")
    inputs-textarea(tag-scope="{ this.tagScope }.inputs.description")
    inputs-complex-checkbox-phase(tag-scope="{ this.tagScope }.inputs.phases")

    .phase_wrap(class="{ show: opts.phase_1 }" data-color="{opts.phase_1_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_1.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_1.description")

    .phase_wrap(class="{ show: opts.phase_2 }" data-color="{opts.phase_2_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_2.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_2.description")

    .phase_wrap(class="{ show: opts.phase_4 }" data-color="{opts.phase_4_colorcode}")
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.phase_4.material_id")
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.phase_4.heat_treatment_id")
      inputs-number-comma(tag-scope="{ this.tagScope }.inputs.phase_4.unit_price")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_4.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_4.description")

    .phase_wrap(class="{ show: opts.phase_8 }" data-color="{opts.phase_8_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_8.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_8.description")

    .phase_wrap(class="{ show: opts.phase_16 }" data-color="{opts.phase_16_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_16.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_16.description")

    .phase_wrap(class="{ show: opts.phase_32 }" data-color="{opts.phase_32_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_32.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_32.description")
      inputs-complex-checkbox-check-todo(tag-scope="{ this.tagScope }.inputs.phase_32.todo")
      inputs-complex-checkbox-check-reports(tag-scope="{ this.tagScope }.inputs.phase_32.reports")
      inputs-complex-check-special-reports(tag-scope="{ this.tagScope }.inputs.phase_32.special_reports")

    .phase_wrap(class="{ show: opts.phase_64 }" data-color="{opts.phase_64_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_64.fixed_status")
      inputs-textarea.phase-64-textarea(tag-scope="{ this.tagScope }.inputs.phase_64.description")
      inputs-complex-location-inserter(tag-scope="{ this.tagScope }.inputs.recent_locations" callback-insert="{callbackLocationInsert}")
      inputs-complex-delivery-attachments(tag-scope="{ this.tagScope }.inputs.phase_64.attachments")
      inputs-complex-delivery-other-attachments(tag-scope="{ this.tagScope }.inputs.phase_64.other_attachments")
      inputs-complex-delivery-attachments-for-circle(tag-scope="{ this.tagScope }.inputs.phase_64.attachments_for_circle")

    .phase_wrap(class="{ show: opts.phase_128 }" data-color="{opts.phase_128_colorcode}")
      inputs-radio-multiple(tag-scope="{ this.tagScope }.inputs.phase_128.fixed_status")
      inputs-textarea(tag-scope="{ this.tagScope }.inputs.phase_128.description")

    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit")
  .orders_based_on_table.mt-5(if="{opts.original_id && opts.orders_table.items.length > 0}")
    hr.mb-3
    h5
      a.strong.mr-2(href="{opts.original_order_show_path}" target="_blank") { opts.original_job_no }
      span { locale().copied_orders_title }
    orders-table(tag-scope="{ this.tagScope }.orders_table")
  script(type="typescript").
    this.mixin('forms.orders.save');
  style(scoped).
    .phase_wrap {
      padding: 1rem 0;
      display: none;
    }
    .phase_wrap.show {
      display: block;
    }
    .phase_wrap .row > label span {
      border-bottom: 4px solid #CCC;
    }
